/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyQuarterRoutingModule
 * Purpose		: Routing module for SummaryofSalesbyQuarter.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SummaryofSalesbyQuarterListComponent } from './SummaryofSalesbyQuarterList.component';
import { SummaryofSalesbyQuarterDetailsComponent } from './SummaryofSalesbyQuarterDetails.component';

const SummaryofSalesbyQuarterRoutes: Routes = [
	{ path: 'SummaryofSalesbyQuarter',  component: SummaryofSalesbyQuarterListComponent },
	{ path: 'SummaryofSalesbyQuarter/Details/:id', component: SummaryofSalesbyQuarterDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(SummaryofSalesbyQuarterRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class SummaryofSalesbyQuarterRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SummaryofSalesbyQuarter/SummaryofSalesbyQuarter-routing.module.ts